import React from 'react';
import { createComponent } from '@workday/canvas-kit-react/common';
import { Flex } from '@workday/canvas-kit-react/layout';
export const ToastBody = createComponent('div')({
    displayName: 'Toast.Body',
    Component: ({ children, ...elemProps }, ref, Element) => {
        return (React.createElement(Flex, Object.assign({ alignItems: "flex-start", flexDirection: "column", justifyContent: "center", paddingY: "s", ref: ref, as: Element, flexGrow: 1, gap: "xxxs" }, elemProps), children));
    },
});
